import { render, staticRenderFns } from "./approvalDetails.vue?vue&type=template&id=02606848&scoped=true&"
import script from "./approvalDetails.vue?vue&type=script&lang=js&"
export * from "./approvalDetails.vue?vue&type=script&lang=js&"
import style0 from "./approvalDetails.vue?vue&type=style&index=0&id=02606848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02606848",
  null
  
)

export default component.exports